<template>
  <div class="dropdown_field" :class="[c_style]">
    <label :for="id" v-show="title != '' && title != null">{{title}}</label>
    <div class="input_area">
      <input readonly :id="id" type="text" :value="current.title" @click="openSelector()">
      <div class="dd_icon" :class="[{active: show_list}]">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M5.83334 8.33334L10 11.6667L14.1667 8.33334" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="dd_list" v-show="show_list">
        <div
            v-for="item in list" class="item" :key="item.id"
            @click="selectItem(item)"
            :class="[{active: item.id == current.id}]"
        >
          {{item.title}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name : "DropdownFiled",
  props : {
    id : String,
    title : String,
    list : Object,
    current : Object,
    c_style: String
  },
  data() {
    return{
      currentItem : this.current,
      show_list : false,
    }
  },
  methods: {
    openSelector : function() {
      if(!this.show_list) {this.show_list = true;} else {this.show_list = false;}
    },
    selectItem : function(item) {
      this.currentItem.id = item.id;
      this.currentItem.title = item.title;

      this.show_list = false;

      this.$emit("change", item.id);
    }
  }
}
</script>

<style scoped>

.dropdown_field{
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  width: 100%;
}

.dropdown_field.w262 {
  flex: unset;
  width: 262px;
}

.dropdown_field label {
  cursor: pointer;
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  padding-left: 20px;
}

.dropdown_field input {
  padding: 15px 20px;
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  outline: none;
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}

.dropdown_field.white input{
  background: var(--White);
  color: var(--Black);
}

.input_area {
  position: relative;
  cursor: pointer;
}

.dd_icon {
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 20px;
  display: flex;
}

.dd_icon.active svg{
  transform: rotate(180deg);
}

.dd_list {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  box-shadow: 0px 6px 50px 0px rgba(0, 0, 0, 0.08);
  margin-top: 4px;
  position: absolute;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  z-index: 10;
  max-height: 300px;
  overflow: auto;
}

.dd_list .item {
  padding: 12px 20px;
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 124%;
}

.dd_list .item:hover {
  border-radius: 8px;
  background: var(--BG, #F8F8F8);
}

.dd_list .item.active {
  border-radius: 8px;
  background: rgba(27, 120, 188, 0.10);
  color: var(--Blue, #1B78BC);
}



.dd_list::-webkit-scrollbar {
  width: 3px; /* Ширина всего элемента навигации */
}

.dd_list::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

.dd_list::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 3px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}

</style>